import * as React from "react";
import {useEffect} from "react";
import * as AceDiff from 'ace-diff';
import 'ace-diff/dist/ace-diff-dark.min.css';
import 'brace/mode/groovy'
import 'brace/ext/searchbox'
import {Button, Grid, Header, Modal} from "semantic-ui-react";

const ace = require('brace');

export interface ScriptCherryPickModalProps {
    left: string,
    right: string,
    leftTitle: string,
    rightTitle: string,
    isOpen: boolean,
    onClose: () => void
    onSave: (newLeft: string) => void
}

export function ScriptCherryPickModal(props: React.PropsWithChildren<ScriptCherryPickModalProps>) {


    const [editors, setEditors] = React.useState<any>()


    useEffect(() => {
        let aceDiff = new AceDiff({
            ace,
            element: ".acediff",
            left: {
                content: props.left,
                copyLinkEnabled: false
            },
            right: {
                content: props.right,
                editable: false
            },
        });
        if (aceDiff.editors) {
            //console.log(aceDiff.getEditors().left.getValue())
            setEditors(aceDiff.getEditors())
        }
    }, [])

    function onSave() {
        console.log("editors.left: ", editors.left.getValue())
        props.onSave(editors.left.getValue())
        props.onClose()
    }

    function handleClose() {
        props.onClose()
    }

    return <Modal
        open={props.isOpen}
        onClose={handleClose}
        dimmer="inverted"
        size='fullscreen'>
        <Header icon='browser' content='CherryPick'/>
        <Modal.Content>

            <Grid>
             <Grid.Row>
                <Grid.Column width={8} textAlign={"center"}>
                    <Header as='h4'>{props.leftTitle}</Header>
                </Grid.Column>
                <Grid.Column width={8} textAlign={"center"}>
                    <Header as='h4'>{props.rightTitle}</Header>
                </Grid.Column>
            </Grid.Row>
            </Grid>
            <div className="acediff"/>
            <Button
                icon='copy'
                content='Copy Right'
                color='blue'
                onClick={(evt) => {
                    if (editors) {
                        editors.left.setValue(editors.right.getValue())
                    }
                }}
            />
            <Button
                icon='save'
                content='Save'
                color='green'
                onClick={(evt) => onSave()}
            />
            <Button
                icon='cancel'
                content='Cancel'
                color='red'
                onClick={(evt) => handleClose()}
            />


        </Modal.Content>
    </Modal>

}
